import React from 'react';
import { toast } from 'react-toastify';

// import moment from 'moment';
// import { store } from '../store';

export function constructErrorElement(errorContent) {
  const errorStatusCode = errorContent.response.status;
  const errorData = errorContent.response.data;
  let errorElement = null;

  /* eslint-disable implicit-arrow-linebreak */
  console.log('constructErrorElement.errorData:', errorData);
  if (errorData) {
    errorElement = (
      <span className="bg-white m-1 p-2 small text-body ">
        {
          Object.keys(errorData).forEach((key) => (
            <span>
              <b>
                {key}
                :
              </b>
              {errorData[key]}
            </span>
          ))
        }
      </span>
    );
  }
  return {
    errorStatusCode,
    errorElement,
  };
}

export function showPopup(headerText, bodyText, popupType = null, errorContent = null) {
  const { errorElement } = errorContent ? constructErrorElement(errorContent) : {};
  const toastElement = (
    <div
      className="d-flex flex-column p-1"
      style={{
        cursor: 'auto',
      }}
    >
      <div className="h3">
        {headerText}
      </div>
      <div className="d-flex flex-column">
        {bodyText}
        {errorElement}
      </div>
    </div>
  );

  // TODO(@joeysapp): Above functionality should be toast-agnostic
  const toastOptions = { autoClose: true };
  const toastToShow = popupType || headerText;

  switch (toastToShow.toLowerCase()) {
    case 'error':
      toast.error(toastElement, toastOptions);
      break;
    case 'info':
      toast.info(toastElement, toastOptions);
      break;
    case 'success':
      toast.success(toastElement, toastOptions);
      break;
    default:
      toast.success(toastElement, toastOptions);
      break;
  }
}
